import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class BankingPortfolioService {
	private readonly uri: string = `${environment.DO_URL}/v1`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	getBankingPortfolios(): Observable<any> {
		return this.http.get(`${this.uri}/banking-portfolios`);
	}
}
